import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { connect } from 'react-redux';
import { addComment } from 'bundles/apex/deals/show/store/comments/actions';

import TaggedBodyInput from 'bundles/apex/deals/tagged_body/input';

// Tagify doesn't consistently play nice with hooks
export class DealCommentInput extends React.Component {
  static propTypes = {
    addComment: PropTypes.func.isRequired,
    comment: PropTypes.shape({
      availableTagsPath: PropTypes.string.isRequired,
      body: PropTypes.string,
      bodyParts: PropTypes.array.isRequired,
    }),
    deal: PropTypes.shape({
      availableTagsPath: PropTypes.string.isRequired,
    }).isRequired,
    submitOnEnter: PropTypes.bool,
    onChange: PropTypes.func,
  }

  state = {
    submitOnEnter: this.props.submitOnEnter,
    value: this.props.comment?.body || '',
  }

  submit = () => {
    if (!this.state.submitOnEnter) {
      return;
    }

    if (this.state.value.replaceAll(/\n|\s/g, '')) {
      this.props.addComment(this.state.value);
      this.setState({ value: '' });
    }
  }

  onChange = (value) => {
    this.setState({ value });
    this.props.onChange?.(value);
  }

  render() {
    const availableTagsPath = this.props.comment?.availableTagsPath || this.props.deal.availableTagsPath;

    return (
      <div className="d-flex align-items-center position-relative">
        <TaggedBodyInput
          autoFocus
          availableTagsPath={`${availableTagsPath}&groups[]=users`}
          body={this.state.value}
          bodyParts={this.props.comment?.bodyParts}
          placeholder="Type Message"
          tooltipPosition="top left"
          onChange={this.onChange}
          onDropdownHide={() => this.setState({ submitOnEnter: this.props.submitOnEnter })}
          onDropdownShow={() => this.setState({ submitOnEnter: false })}
          onKeyDown={(event, originalEvent) => (event.key === 'Enter' && !event.shiftKey) && this.submit(originalEvent)}
        />

        {this.props.submitOnEnter &&
          <span
            className={classNames('position-absolute end-0 me-3', {
              'clickable': this.state.value,
              'text-muted': !this.state.value,
            })}
            onClick={this.submit}
          >
            Send
          </span>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  deal: state.deal,
});

const mapDispatchToProps = {
  addComment,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealCommentInput);
